import React from "react";
import PageTitle from "../PageTitle";
import { doRequest, dovocalRequest } from "../../helper";
import $ from "jquery";
import { NavLink } from "react-router-dom";
import LazyLoad from "react-lazyload";
import axios from "axios";
import { saveAs } from "file-saver";

export default class ViksitBharatSelfie extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      response: null,
      postCount: 0,
      status: "",
      points: "",
      // lastEvaluatedKey: "",
      loadMoreDisplay: false,
      selectedPhotos: [],
      isChecked: false,
      limit: 100,
      page: 1,
      selectedButton: null,
    };
    this.update = this.update.bind(this);
    this.getGallerydata = this.getGallerydata.bind(this);
    this.selectToggle = this.selectToggle.bind(this);
  }

  componentDidMount() {
    var status = this.props.match.params.status;
    if (!status) {
      status = "ok";
    }
    this.getGallerydata("loadmore", this.state.page, status);
  }

  getGallerydata(loadmore, pageno, status, point) {
    $("#loader").css({ display: "block" });
    var ref = this;
    ref.setState({
      status: status,
    });
    if (point == "disable") {
      ref.setState({
        points: "disabled",
      });
    }
    if (point == "enable") {
      ref.setState({
        points: "ok",
      });
    }
    if (!loadmore) {
      ref.setState({ items: [], page: 1 });
    }
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch(
      `https://d1p91tziu2biez.cloudfront.net/v1/post/postlistformodration?page=${
        pageno ? pageno : this.state.page
      }&limit=${this.state.limit}&status=${status}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result &&
          result["resultFlag"] == "1" &&
          result["resultFlag"] == 1
        ) {
          if (status == "disabled") {
            if (loadmore) {
              ref.setState(
                {
                  items: [...ref.state.items, ...result.response],
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            } else {
              ref.setState(
                {
                  items: [...result.response],
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            }
          } else {
            ref.setState(
              {
                items: [...ref.state.items, ...result.response],
              },
              () => {
                $("#loader").css({ display: "none" });
              }
            );
          }
          if (result.response.length.toString() >= this.state.limit) {
            ref.setState({
              loadMoreDisplay: true,
            });
          } else {
            ref.setState({
              loadMoreDisplay: false,
            });
          }
        }
      })
      .catch((error) => console.log("error", error));
  }

  update(id, status) {
    // $("#loader").css({ display: "block" });
    var ref = this;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      post_id: id,
      post_status: status,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    fetch(
      "https://d1p91tziu2biez.cloudfront.net/v1/post/updatepoststatus",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.l;
        if (result && result["resultFlag"] == 1) {
          $("#post_" + id).hide();
        }
      })
      .catch((error) => console.log("error", error));
  }

  loadMoreData = () => {
    this.setState({
      page: this.state.page + 1,
    });
    $("#loader").css({ display: "block" });
    this.getGallerydata("loadmore", this.state.page + 1, this.state.status);
    $("#loader").css({ display: "none" });
  };

  selectToggle() {
    if ($(".allChecked").length > 0) {
      $(".multi_select").prop("checked", false);
      $(".multi_select").removeClass("allChecked");
    } else {
      $(".multi_select").prop("checked", true);
      $(".multi_select").addClass("allChecked");
    }
  }

  UnselectChekbox = () => {
    this.setState({ selectedPhotos: [] });
  };

  render() {
    var bread = "Viksit Bharat Selfie / Moderation (Disabled Posts)";
    var pagelink = "/viksitbharatselfie/moderation";
    if (this.state.status == "disabled") {
      bread = "Viksit Bharat Selfie/ Moderation (Disabled Posts)";
      pagelink += "/disabled";
    } else if (this.state.status == "ok") {
      bread = "Viksit Bharat Selfie/ Moderation (Enabled Posts)";
      pagelink += "/enabled";
    } else {
      bread = "Viksit Bharat Selfie/ Moderation (Enabled Posts)";
      pagelink += "/disabled";
    }
    var items = this.state.items;
    var links = [
      {
        link: "/viksitbharatselfie/moderation/disabled",
        name: "View Disabled Posts",
      },
      {
        link: "/viksitbharatselfie/moderation/enabled",
        name: "View Active Posts",
      },
    ];
    var pagination = [];
    if (this.state.response && countdata) {
      var countdata = this.state.response.countdata;
      var pages = Math.ceil(countdata.Count / this.state.limit);

      for (var i = 1; i <= pages; i++) {
        pagination.push(
          <span key={i}>
            <NavLink to={pagelink + "/" + i} className="btn btn-primary btn-xs">
              {i}
            </NavLink>
            &nbsp;
          </span>
        );
      }
    }

    const { selectedPhotos } = this.state;
    const { isChecked } = this.state;
    return (
      <div>
        <PageTitle
          title="#Viksit Bharat Selfie"
          bread={bread}
          //   links={links}
          Count={this.state.postCount}
        />
        <div className="wrapper wrapper-content">
          <br />
          <div className="form-inline form_right">
            <div>
              <button
                className={
                  this.state.points === "ok"
                    ? `btn btn-success btn-rounded`
                    : `btn btn-primary btn-rounded`
                }
                onClick={() => this.getGallerydata("", 1, "ok", "enable")}
              >
                Enable
              </button>
              <button
                className={
                  this.state.points === "disabled"
                    ? `btn btn-success btn-rounded`
                    : `btn btn-primary btn-rounded`
                }
                onClick={() =>
                  this.getGallerydata("", 1, "disabled", "disable")
                }
              >
                Disabled
              </button>

              {/* <button
                className="btn-success"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Clear filters
              </button> */}
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                <p
                  id="nodatafound"
                  style={{
                    display: "none",
                    textAlign: "center",
                    position: "relative",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  No Data Found
                </p>
                {Array.isArray(items) &&
                  items.map((value, index) => {
                    console.log("val", value);
                    let imageArr = value.images && JSON.parse(value.images);
                    return (
                      <div class="file-box" key={index} id={"post_" + value.id}>
                        <div class="file">
                          <a href="javascript:void(0);">
                            <span class="corner"></span>
                            <LazyLoad>
                              <div class="image" style={{ height: "auto" }}>
                                <div className="user_image_list">
                                  <ul>
                                    <li>
                                      <a>
                                        <img
                                          src={
                                            value.s3_post_url
                                              ? value.s3_post_url
                                              : value.post_url
                                          }
                                          alt=""
                                        />
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="image_caption">
                                  <a
                                    href="javascript:void(0);"
                                    className="btn btn-warning btn-circle"
                                    onClick={() => {
                                      this.update(value.id, "disabled");
                                    }}
                                    type="button"
                                  >
                                    <i className="fa fa-times"></i>
                                  </a>
                                </div>
                              </div>
                            </LazyLoad>
                            <div class="file-name">
                              {value.effect_name ? value.effect_name : ""}
                              <br />

                              <small>
                                Added:{" "}
                                {value.created_at ? value.created_at : ""}
                              </small>
                            </div>
                          </a>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            {this.state.loadMoreDisplay && (
              <button
                style={{
                  position: "relative",
                  left: "50%",
                  transform: "translateX(-50%)",
                  padding: "10px 18px",
                }}
                type="button"
                onClick={this.loadMoreData}
              >
                Load More
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/ViksitBharatSelfie/ViksitBharatSelfie.jsx